import { render, staticRenderFns } from "./ChipGroupScience.vue?vue&type=template&id=8bc1a8a8&"
import script from "./ChipGroupScience.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChipGroupScience.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bc1a8a8')) {
      api.createRecord('8bc1a8a8', component.options)
    } else {
      api.reload('8bc1a8a8', component.options)
    }
    module.hot.accept("./ChipGroupScience.vue?vue&type=template&id=8bc1a8a8&", function () {
      api.rerender('8bc1a8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupScience/ChipGroupScience.vue"
export default component.exports